import { uploadFiles } from "components/util/file_util";

// A comment typed straight into the panel, with nothing but words in it. No longer
// written — the panel only offers pointing at the prototype now — but revisions saved
// before that still hold these, so the card keeps knowing how to show one.
export const ADDITIONAL_ANNOTATION = "prototype_additional";
// A comment made by pointing at the prototype: the user framed a piece of the rendered
// page and wrote about that. The image travels as a stored file so the revision JSON
// keeps holding text.
export const SCREENSHOT_ANNOTATION = "prototype_screenshot";

// Both prototype screens keep their comments in the same list and show the same card,
// so the shape is built here once. What differs between them is only who is writing
// (the reviewer knows the author, the builder does not) and how the list is saved.
export const buildAnnotation = ({
  author = "",
  isDeveloper = false,
  screenshot = null,
  text = "",
  type = SCREENSHOT_ANNOTATION,
}) => ({
  id: crypto.randomUUID(),
  type,
  visibility_scope: isDeveloper ? "DEV" : "CLIENT",
  is_solved: false,
  text,
  author,
  screenshot,
  order: Date.now() + Math.random(),
});

// A developer sees everything; a client never sees what was written for the team. The
// number is assigned after filtering so the panel and whoever reads the comments later
// are looking at the same "comment 3".
export const getVisibleAnnotations = (annotations = [], isDeveloper = false) =>
  annotations
    .filter((annotation) => annotation.id)
    .filter((annotation) => isDeveloper || (annotation.visibility_scope || "CLIENT") != "DEV")
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((annotation, index) => ({ ...annotation, annotationNumber: index + 1 }));

// The overlay hands back a PNG blob. It is uploaded like any other file, so the
// annotation ends up holding the same `{ id, url, name }` object every other stored
// file in a revision does.
export const uploadScreenshot = async (blob, flowId) => {
  const file = new File([blob], `prototype-${Date.now()}.png`, { type: "image/png" });
  const [stored] = await uploadFiles([file], flowId);
  return stored || null;
};
